import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Card from "react-bootstrap/esm/Card";

function PlayerCard(props) {
  const [height, setHeight] = useState(64);
  const [width, setWidth] = useState(64);
  const bingo = ["B", "I", "N", "G", "O"];
  const [bingoNumbers, setBingoNumbers] = useState([
    {
      letter: "",
      location: 0,
      number: 0,
    },
  ]);

  const tileRef = useRef([]);

  const findDuplicateValues = (array) => {
    let sortedArray = array.slice().sort();
    let dupFound = 0;
    for (let i = 0; i < sortedArray.length; i++) {
      if (sortedArray[i] === sortedArray[i + 1]) {
        dupFound = 1;
      }
    }
    return dupFound;
  };

  const handleBingoNumbers = () => {
    let bingoNumArray = [];
    let dup = 0;
    let bData = [];
    let iData = [];
    let nData = [];
    let gData = [];
    let oData = [];
    do {
      bingoNumArray = [];
      for (let i = 0; i < 5; i++) {
        bingoNumArray.push(Math.floor(Math.random() * 15 + 1));
      }
      for (let i = 0; i < 5; i++) {
        bingoNumArray.push(Math.floor(Math.random() * 15 + 16));
      }
      for (let i = 0; i < 5; i++) {
        bingoNumArray.push(Math.floor(Math.random() * 15 + 31));
      }
      for (let i = 0; i < 5; i++) {
        bingoNumArray.push(Math.floor(Math.random() * 15 + 46));
      }
      for (let i = 0; i < 5; i++) {
        bingoNumArray.push(Math.floor(Math.random() * 15 + 61));
      }
      dup = findDuplicateValues(bingoNumArray);
    } while (dup === 1);
    for (let i = 0; i < bingo.length; i++) {
      bData.push({
        letter: "B",
        location: i,
        number: bingoNumArray[i],
      });
      iData.push({
        letter: "I",
        location: i,
        number: bingoNumArray[i + 5],
      });
      nData.push({
        letter: "N",
        location: i,
        number: bingoNumArray[i + 10],
      });
      gData.push({
        letter: "G",
        location: i,
        number: bingoNumArray[i + 15],
      });
      oData.push({
        letter: "O",
        location: i,
        number: bingoNumArray[i + 20],
      });
    }
    setBingoNumbers([bData, iData, nData, gData, oData]);
  };

  useEffect(() => {
    handleBingoNumbers();
  }, []);

  useEffect(() => {
    if (bingoNumbers.length > 1) {
      props.setBingoNumbers(bingoNumbers);
      props.setFreeNum(bingoNumbers[2][2].number);
    }
  }, [bingoNumbers]);

  const identity = (id, row, tile, xCoord, yCoord) => {
    let zid = id.split("");
    let letter = zid[0];
    let number = zid[1];
    let bingObj = bingoNumbers[row];
    props.setSelectedTile(tileRef[tile]);
    props.setSelectionFlag(!props.selectionFlag);
    props.setUserSelect(bingObj[number]);
    props.setSelectCoord({ x: xCoord, y: yCoord });
  };

  let yCoord = 1;
  return (
    <>
      <Card
        style={{
          padding: "25px",
          minWidth: width * 5,
          minHeight: height * 5,
          fontFamily: "Roboto",
        }}
      >
        {bingoNumbers.length > 1 ? (
          <Row>
            {bingo.map((letter, x) => {
              return (
                <>
                  <Col
                    key={letter + "main"}
                    style={{ width: "100%", padding: "0" }}
                  >
                    <h1
                      key={letter + "h1"}
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {letter}
                    </h1>
                    <Col
                      style={{
                        border: "solid 1px #333",
                        height: height,
                      }}
                      key={letter + "0"}
                      onClick={() =>
                        identity(letter + "0", x, x, x + 1, yCoord)
                      }
                      ref={(ref) => (tileRef[x] = ref)}
                    >
                      <h1
                        key={letter + "h1"}
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {bingoNumbers[x].map((obj) => {
                          if (obj.letter === letter && obj.location === 0) {
                            return obj.number;
                          }
                        })}
                      </h1>
                    </Col>
                    <Col
                      style={{
                        border: "solid 1px #333",
                        height: height,
                      }}
                      key={letter + "1"}
                      onClick={() =>
                        identity(letter + "1", x, x + 5, x + 1, yCoord + 1)
                      }
                      ref={(ref) => (tileRef[x + 5] = ref)}
                    >
                      <h1
                        style={{
                          textAlign: "center",
                        }}
                        key={letter + "h1"}
                      >
                        {bingoNumbers[x].map((obj) => {
                          if (obj.letter === letter && obj.location === 1) {
                            return obj.number;
                          }
                        })}
                      </h1>
                    </Col>
                    <Col
                      style={{
                        border: "solid 1px #333",
                        height: height,
                      }}
                      key={letter + "2"}
                      onClick={() =>
                        identity(letter + "2", x, x + 10, x + 1, yCoord + 2)
                      }
                      ref={(ref) => (tileRef[x + 10] = ref)}
                    >
                      <h1
                        style={{
                          textAlign: "center",
                        }}
                        key={letter + "h1"}
                      >
                        {bingoNumbers[x].map((obj) => {
                          if (
                            obj.letter === letter &&
                            obj.location === 2 &&
                            x === 2
                          ) {
                            return "FREE";
                          }
                          if (obj.letter === letter && obj.location === 2) {
                            return obj.number;
                          }
                        })}
                      </h1>
                    </Col>
                    <Col
                      style={{
                        border: "solid 1px #333",
                        height: height,
                      }}
                      key={letter + "3"}
                      onClick={() =>
                        identity(letter + "3", x, x + 15, x + 1, yCoord + 3)
                      }
                      ref={(ref) => (tileRef[x + 15] = ref)}
                    >
                      <h1
                        style={{
                          textAlign: "center",
                        }}
                        key={letter + "h1"}
                      >
                        {bingoNumbers[x].map((obj) => {
                          if (obj.letter === letter && obj.location === 3) {
                            return obj.number;
                          }
                        })}
                      </h1>
                    </Col>
                    <Col
                      style={{
                        border: "solid 1px #333",
                        height: height,
                      }}
                      key={letter + "4"}
                      onClick={() =>
                        identity(letter + "4", x, x + 20, x + 1, yCoord + 4)
                      }
                      ref={(ref) => (tileRef[x + 20] = ref)}
                    >
                      <h1
                        style={{
                          textAlign: "center",
                        }}
                        key={letter + "h1"}
                      >
                        {bingoNumbers[x].map((obj) => {
                          if (obj.letter === letter && obj.location === 4) {
                            return obj.number;
                          }
                        })}
                      </h1>
                    </Col>
                  </Col>
                </>
              );
            })}
          </Row>
        ) : (
          ""
        )}
      </Card>
    </>
  );
}

export default PlayerCard;
